import {
  FaCertificate,
  FaClock,
  FaCode,
  FaUsers,
  FaVideo,
} from "react-icons/fa";

export const CourseCategory = [
  { value: "1", label: "Web Development" },
  { value: "2", label: "Digital Marketing" },
];
export const CourseLevel = [
  { value: "BEGINNER", label: "Beginner" },
  { value: "INTERMEDIATE", label: "Intermediate" },
  { value: "ADVANCE", label: "Advance" },
  { value: "EXPERT", label: "Expert" },
];
export const CourseVisibility = [
  { value: 0, label: "Public" },
  { value: 1, label: "Private" },
];
export const DiscountTypeOptions = [
  { value: "PERCENTAGE", label: "Persen" },
  { value: "NOMINAL", label: "Nominal" },
];

export const CrossSellOptions = [
  {
    label: "Fundamental UI Design",
    value: 1,
  },
  {
    label: "React for Beginner",
    value: 2,
  },
  {
    label: "Next.js Fullstack Bootcamp",
    value: 3,
  },
  {
    label: "TypeScript for Developer",
    value: 4,
  },
];

export const benefitOptions = [
  {
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <FaCertificate /> Certificate of Completion
      </span>
    ),
    value: 1,
  },
  {
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <FaVideo /> Recorded Video Access
      </span>
    ),
    value: 2,
  },
  {
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <FaClock /> Lifetime Access
      </span>
    ),
    value: 3,
  },
  {
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <FaUsers /> Community Support
      </span>
    ),
    value: 4,
  },
  {
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <FaCode /> Downloadable Source Code
      </span>
    ),
    value: 5,
  },
];
